import React from "react";

const DashHeader = () => {
     return (
         <footer className="main-footer">
             <strong>Copyright &copy; 2019-2023 <a href="https://steplog.ru">StepLog.Ru</a>.</strong>
             <span className="ml-1">All rights reserved.</span>
             <div className="float-right d-none d-sm-inline-block">
                 <b>Version</b> 0.1.0
             </div>
         </footer>

     );
}

export default DashHeader;
